<div #gmap class="height-100-35 map-main" id="map"></div>

<div class="map-buttons">
	<app-gmap-button
		*ngIf="mapService.mapButtons?.pops?.visible"
		[options]="mapService.mapButtons.pops"
		(click)="onClickMapButton('pops')"
	></app-gmap-button>
	<app-gmap-button
		*ngIf="mapService.mapButtons?.pop_agf?.visible"
		[options]="mapService.mapButtons.pop_agf"
		(click)="onClickMapButton('pop_agf')"
	></app-gmap-button>
	<app-gmap-button
		*ngIf="mapService.mapButtons?.pcn?.visible"
		[options]="mapService.mapButtons.pcn"
		(click)="onClickMapButton('pcn')"
	></app-gmap-button>
	<app-gmap-button
		*ngIf="mapService.mapButtons?.pop_all?.visible"
		[options]="mapService.mapButtons.pop_all"
		(click)="onClickMapButton('pop_all')"
	></app-gmap-button>
</div>
